import { render } from "./app-logo-power-by.vue?vue&type=template&id=28385d7c"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-power-by.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28385d7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28385d7c', __exports__)) {
    console.log('reload')
    api.reload('28385d7c', __exports__)
  }
  
  module.hot.accept("./app-logo-power-by.vue?vue&type=template&id=28385d7c", () => {
    console.log('re-render')
    api.rerender('28385d7c', render)
  })

}


export default __exports__